import { render, staticRenderFns } from "./VuesticWizard.vue?vue&type=template&id=b7e60c74&scoped=true"
import script from "./VuesticWizard.vue?vue&type=script&lang=js"
export * from "./VuesticWizard.vue?vue&type=script&lang=js"
import style0 from "./VuesticWizard.vue?vue&type=style&index=0&id=b7e60c74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e60c74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7e60c74')) {
      api.createRecord('b7e60c74', component.options)
    } else {
      api.reload('b7e60c74', component.options)
    }
    module.hot.accept("./VuesticWizard.vue?vue&type=template&id=b7e60c74&scoped=true", function () {
      api.rerender('b7e60c74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-wizard/VuesticWizard.vue"
export default component.exports